import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts); // Подключение модуля для дополнительного функционала

const PointsChart = ({ data }) => {
	// Преобразуем данные для Highcharts
	const chartData = data.map(point => ({
		x: new Date(point.date).getTime(), // Дата на оси X
		y: point.points, // Количество очков на оси Y
	}));

	// Конфигурация Highcharts
	const options = {
		chart: {
			type: 'line',
			height: 200,
			backgroundColor: null, // Прозрачный фон
			style: {
				fontFamily: 'Arial, sans-serif',
			},
		},
		title: {
			text: null, // Заголовок графика
			style: {
				color: '#333333',
				fontSize: '16px',
			},
		},
		xAxis: {
			type: 'datetime',
			// title: {
			// 	text: 'Date',
			// 	style: {
			// 		color: '#333333',
			// 		fontSize: '12px',
			// 	},
			// },
			labels: {
				style: {
					fontSize: '10px', // Размер шрифта меток оси X
					color: '#666666',
				},
			},
		},
		yAxis: {
			title: {
				text: null,
				style: {
					color: '#333333',
					fontSize: '12px',
				},
			},
			labels: {
				style: {
					fontSize: '10px', // Размер шрифта меток оси Y
					color: '#666666',
				},
			},
			gridLineWidth: 1, // Толщина линий сетки
			gridLineColor: '#e0e0e0', // Цвет линий сетки
		},
		series: [{
			name: 'Points',
			data: chartData,
			color: '#DD6B20', // Цвет линии графика
			marker: {
				enabled: true, // Включение маркеров на графике
				radius: 4, // Размер маркеров
				fillColor: '#ffffff', // Цвет фона маркеров
				lineWidth: 2, // Ширина линии маркера
				lineColor: '#DD6B20', // Цвет линии маркера
			},
			tooltip: {
				pointFormat: 'Marks: <b>{point.y}</b>', // Формат всплывающей подсказки
			},
			animation: {
				duration: 1000, // Длительность анимации
			},
		}],
		credits: {
			enabled: false, // Отключаем кредиты
		},
		legend: {
			enabled: false, // Отключаем легенду
		},
		exporting: {
			enabled: false, // Отключает кнопки экспорта
		},
		responsive: {
			rules: [{
				condition: {
					maxWidth: 600 // Предел для мобильных устройств
				},
				chartOptions: {
					xAxis: {
						labels: {
							style: {
								fontSize: '8px', // Размер шрифта меток оси X на мобильных
							},
						},
					},
					yAxis: {
						labels: {
							style: {
								fontSize: '8px', // Размер шрифта меток оси Y на мобильных
							},
						},
					},
					title: {
						style: {
							fontSize: '14px', // Размер шрифта заголовка на мобильных
						},
					},
				}
			}]
		}
	};

	return (
		<div style={{ width: '100%' }}>
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default PointsChart;